import { Get } from "@/api/axios.config.js";

/** @author hanxuejian 买1增N活动
 * 产品对接：安文景 服务端对接：张鑫
 * method: POST
 * url:/v1/payactivity/common_activity/phone_reservation_status
 * API文档: 无
 * 参数名          是否必须参数     备注
 * activity_name     是          活动名称
 **/

export function phoneReservationStatus({ data = {}, headers = {} } = {}) {
    const url = "v1/payactivity/common_activity/phone_reservation_status";
    return Get({
        url,
        data,
        headers,
        timeout: 1000 * 100,
    });
}


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/api/phone_reservation_status.api.js